import { render, staticRenderFns } from "./clients-edit-tab.vue?vue&type=template&id=3c9506b6&scoped=true"
import script from "./clients-edit-tab.vue?vue&type=script&lang=js"
export * from "./clients-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./clients-edit-tab.vue?vue&type=style&index=0&id=3c9506b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9506b6",
  null
  
)

export default component.exports